export { getCompanies } from "./api";
export { CompanyCard } from "./ui/CompanyCard/CompanyCard";
import companiesState from "./store/companiesState";
export default companiesState;